/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_SendInputs */

const en_chat_send = /** @type {(inputs: Chat_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send`)
};

const th_chat_send = /** @type {(inputs: Chat_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ส่ง`)
};

const ja_chat_send = /** @type {(inputs: Chat_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send`)
};

const fr_chat_send = /** @type {(inputs: Chat_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send`)
};

const es_chat_send = /** @type {(inputs: Chat_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send`)
};

const ru_chat_send = /** @type {(inputs: Chat_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send`)
};

const zh_chat_send = /** @type {(inputs: Chat_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send`)
};

const vi_chat_send = /** @type {(inputs: Chat_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gửi`)
};

/**
* | output |
* | --- |
* | "Send" |
*
* @param {Chat_SendInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const chat_send = /** @type {((inputs?: Chat_SendInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_SendInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_chat_send(inputs)
	if (locale === "ja") return ja_chat_send(inputs)
	if (locale === "fr") return fr_chat_send(inputs)
	if (locale === "es") return es_chat_send(inputs)
	if (locale === "ru") return ru_chat_send(inputs)
	if (locale === "zh") return zh_chat_send(inputs)
	if (locale === "vi") return vi_chat_send(inputs)
	return en_chat_send(inputs)
});